import { FunctionComponent } from 'react'

import { MultilineHighFiveContent } from '@widgets/Multiline/types'
import CardContent from '@components/Multiline/HighFive/CardContent'
import HighFiveLayout from '@components/Multiline/HighFive/HighFiveLayout'

import { getLatestDate, getTimeframeString, isHighFiveContent } from './utils'

export interface HighFiveMultilineProps {
  children: MultilineHighFiveContent
}

const HighFiveMultiline: FunctionComponent<HighFiveMultilineProps> = ({
  children,
}) => {
  if (!isHighFiveContent(children)) {
    return null
  }

  const items = children.map(
    (
      { content: [{ title, description, link, articleId }, ..._rest] },
      index
    ) => ({
      title,
      description,
      link,
      articleId,
      order: index + 1,
    })
  )

  const timeframe = getTimeframeString()
  const updatedDates = children.map(
    ({ content: [{ updatedDate }, ..._rest] }) => ({
      ...updatedDate,
    })
  )
  const lastUpdatedDate = getLatestDate(updatedDates)
  return (
    <HighFiveLayout
      formattedUpdatedDate={lastUpdatedDate}
      timeframe={timeframe}>
      {items.map((item) => (
        <CardContent key={item.order} {...item} />
      ))}
    </HighFiveLayout>
  )
}

export default HighFiveMultiline
